import React, { useState, useEffect } from 'react'
import $ from 'jquery';
import 'jquery-form';
import 'jquery-validation';
import '../../assets/scripts/jquery-validation.init';
import swal from 'sweetalert2';
import moment from 'moment';
import * as helper from '../global/helper';
import { mobileOtpRequest, verifyAndUpdateAgentMobile } from '../api/agentAPI';
import { getAuthState } from '../../assets/scripts/login-util';
import './emailVerificationModal.css'

/**
 * Task 37 - a close structural clone of emailVerificationModal.js,
 * adapted for mobile/2Factor. The one real difference from that file:
 * Mobile is not a login credential, so a successful change does not
 * replace the auth cookie or reissue a token - it just reloads, the same
 * way the email modal's own final step does, so this page picks up the
 * new number from a fresh fetch.
 */
const MobileVerificationModal = (props) => {

    const [Mobile,          setMobile]          = useState('');
    const [OTP,              setOtp]             = useState('')
    const [timer,           setTimer]           = useState(20)
    const [otpTimer,        setOtpTimer]        = useState(180)
    const [counter,         setCounter ]        = useState({m:3, s: 0})
    const [intervalId,      setIntervalId]      = useState({});
    const [OtpRequest,      setOtpRequest]      = useState(false);
    const [serverTimeStamp, setServerTimeStamp] = useState();

    useEffect(() => {
        $('#mobile-verification-modal').modal({ backdrop: 'static',});

        $('#mobile-verification-modal').on('hidden.bs.modal', function () {
            props.onDismissModal('verifyMobile', false);
        });
        $('#mobile-verification-modal').modal('toggle');
    }, [props.show]);

    useEffect(() => {
        if(serverTimeStamp){
            const OTPExpirationSeconds = moment().diff(serverTimeStamp, 'seconds')
            showTimer(180 - OTPExpirationSeconds);
        }
    }, [serverTimeStamp])

    useEffect(()=>{
        let ignore = false;

        const updateCounter = () =>{
            let d = otpTimer % (60 * 60 );
            let ds = Math.ceil(d % 60);
            let t = {m : Math.floor(d/ 60), s: ds < 10 ?`0${ds}`:ds}
            setCounter(t)
        }

        if(!ignore) updateCounter();
        return () =>{
            ignore = true;
        }
    }, [otpTimer])

    const showTimer = (secondsToExpire) => {
        if(secondsToExpire < 0) {
            setOtpTimer(0);
            setTimer(0)
            return
        }
        //OTP RESEND TIMER
        setTimer(20)
        const resendInterval = setInterval(() => {
            setTimer(t =>{
                if(t > 0){
                    return (t-1)
                }else{
                    clearInterval(resendInterval)
                    return 0
                }
            })
        }, 1000);

        //OTP EXP TIMER
        let otpInterval;
        if(secondsToExpire <= 180 && secondsToExpire > 0){
            setOtpTimer(secondsToExpire);
            otpInterval = setInterval(() => {
                setOtpTimer(t =>{
                    if(t > 0){
                        return (t-1)
                    }else{
                        clearInterval(otpInterval)
                        return 0
                    }
                })
            }, 1000);
        }
        //SET IntervalIds for Resetting
        setIntervalId({ resendInterval, otpInterval });
    }

    const codeChangeHandler = (e) => setOtp(e.target.value.trim());
    const mobileChangeHandler = (e) => setMobile(e.target.value.trim());

    const resetTime = () => {
        clearInterval(intervalId.resendInterval);
        clearInterval(intervalId.otpInterval);
    }

    const resendHandler = async () => {
        try {
            let response = await mobileOtpRequest(Mobile);
            if(response){
                //Clear Inputs
                setOtp('');
                resetTime();
                setServerTimeStamp(response.serverTimestamp);
            }
        } catch (err) {
            swal.fire({
                icon        : 'error',
                titleText   : err.message,
                animation   : true,
                customClass : { popup: 'margin-20', },
            });
        }
    }

    const verifyMobileHandler = async () => {
        const btn = $("#verifyMobile-btn");
        const form = $("#mobile-verification-form");
        form.validate({
            // 2Factor's OTP is 4 digits (not the 6 the email flow's
            // self-generated OTP uses - see helperRepository.getOTP(6)),
            // so this can't just copy emailVerificationModal.js's rule.
            rules: {
                Code: { required: true, minlength: 4, maxlength: 4 },
            }
        })

        if (!form.valid()) return;

        helper.StartProcessing(btn)
        try {
           const response = await verifyAndUpdateAgentMobile({ mobile: Mobile, otp: OTP });
           if(response){
                //Clear All intervals
                resetTime();

                swal.fire({
                    toast               : true,
                    icon                : 'success',
                    titleText           : `Mobile number verified successfully!`,
                    position            : 'bottom-end',
                    showConfirmButton   : false,
                    timer               : 2500,
                    animation           : true,
                    customClass         : { popup: 'margin-20', },
                });

                $('#mobile-verification-modal').modal('hide');
                window.location.reload();
           }
        } catch (err) {
            if(err.message === 'OTP Expired') setTimer(0)
            swal.fire({
                icon         : 'error',
                titleText    : err.message,
                animation    : true,
                customClass  : { popup: 'margin-20', },
            });
            return helper.StopProcessing(btn);
        }
    }

    const getOtpHandler = async (e) => {
        const currentMobile = (getAuthState('user') || {}).mobile;
        e.preventDefault();
        const btn = $("#getOTP-btn");
        const form = $("#mobile-verification-form");
        form.validate({
            rules: {
                Mobile: { required: true, minlength: 10, maxlength: 10 }
            }
        })
        if (!form.valid()) return;
        form.validate().destroy();

        if(currentMobile && Mobile == currentMobile) return;

        swal.fire({
                icon              : 'warning',
                title             : 'Request Mobile Number Change',
                text              : 'Are You Sure ..!',
                confirmButtonText : 'Yes',
                showCancelButton  : true,
        }).then( async (result) => {
            if (result.isConfirmed) {
                try {
                    helper.StartProcessing(btn);
                    const response = await mobileOtpRequest(Mobile);
                    if(response){
                        setServerTimeStamp(response.serverTimestamp);
                        setOtpRequest(true);
                    }
                    helper.StopProcessing(btn);
                } catch (err) {
                    swal.fire({
                        icon              : "error",
                        titleText         : "Error!",
                        text              :  err.message,
                        buttonsStyling    : false,
                        confirmButtonClass: "btn btn-brand",
                    });
                    return helper.StopProcessing(btn);
                }
            }
        })
    }

    return (
        <div
          className="modal fade"
          id="mobile-verification-modal"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true">

          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                    Change Mobile Number
                </h5>
                <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close">
            </button>
              </div>
              <div className="modal-body">
                <div className="client-container">
                    <div className="row margin-b20">
                        <div className="col text-center">
                        {OtpRequest &&
                            <>
                                <div className="kt-login__desc">
                                    OTP has been sent to <b>+91 {Mobile}</b>.
                                </div>
                                <h5 className="text-center margin-t10"> {(counter.m == 0 && counter.s == 0)?' OTP Expired ':`${counter.m}:${counter.s}`} </h5>
                            </>
                        }
                        </div>
                    </div>

                    <div >
                        <form id="mobile-verification-form" >
                            <input
                                name="Mobile"
                                value={Mobile || ''}
                                className="form-control password-input"
                                type='tel'
                                pattern="[0-9]{10}"
                                minLength="10"
                                maxLength="10"
                                disabled={OtpRequest}
                                onChange={mobileChangeHandler}
                                placeholder="Enter a new 10-digit mobile number"
                            />

                            {OtpRequest &&
                                <input value={OTP}
                                    type="number"
                                    name="Code"
                                    className="form-control "
                                    placeholder="Enter OTP"
                                    autoComplete="off"
                                    maxLength="4"
                                    onChange={codeChangeHandler}
                                />
                            }
                        </form>
                    </div>
                    { OtpRequest &&
                        <div className="row margin-t20">
                            <div className="col text-center">
                                <span className="kt-login__account-msg">
                                    Didn't get it ?
                                </span>
                                &nbsp;&nbsp;
                                {timer > 0 ? `Please wait for ${timer} seconds to Resend OTP `
                                    :<span id="kt_login_otp_resend" className="kt-login__account-link" onClick={resendHandler} > Resend OTP </span>
                                }
                            </div>
                        </div>
                    }
                </div>
              </div>
              <div className="modal-footer">
              {OtpRequest ?
                <button
                    id="verifyMobile-btn"
                    onClick={verifyMobileHandler}
                    disabled={otpTimer === 0}
                    type="button"
                    className="btn btn-brand margin-0">
                    Verify Mobile & Update
                </button>
              : <button
                    type="button"
                    id="getOTP-btn"
                    onClick={getOtpHandler}
                    className="btn btn-success margin-0">
                    Request OTP
                </button>
              }
              </div>
            </div>
          </div>
        </div>
      );
}

export default MobileVerificationModal
